import { getNetworkMenuId, getToken, IS_LOADING, SHOW_SNACKBAR } from "./types";
import {
  addDays,
  endOfDay,
  startOfDay,
  startOfYear,
  startOfMonth,
  endOfMonth,
  addMonths,
  startOfWeek,
  endOfWeek,
  isSameDay,
} from "date-fns";
import { API_KEY } from "./API";

export const getDispatch = (type, res, dispatch) => {
  dispatch({
    type: type,
    payload: res,
  });
};
export const colourStyles = {
  option: (styles, { isFocused }) => {
    return {
      ...styles,
      backgroundColor: isFocused ? "#007aff" : null,
      color: isFocused ? "white" : "black",
      fontSize: "1.4rem",
      padding: "0 12px",
    };
  },
};
export const getSnackbarSuccess = (type, res, dispatch,time) => {
  dispatch({
    type: SHOW_SNACKBAR,
    payload: {
      type: type,
      message: res,
      open: true,
      time:time === 10000 ? time :3000
    },
  });
};

export const ShowImageComponent = ({ imageUrl, showMsg }) => {
  return (
    <a className="upload-img me-2 img-name" target="blank" href={imageUrl}>
      {imageUrl && showMsg}
    </a>
  );
};

export const MandatoryStar = () => {
  return (
    <span
      className="text-danger"
      style={{ border: "none", padding: "0px", marginLeft: "3px" }}
    >
      *
    </span>
  );
};

export const AllowedFile = "image/jpeg, image/jpg, image/png,application/pdf";

export const AllowedFileText = ({ topmargin }) => {
  return (
    <p className="form-text" style={{ marginTop: topmargin }}>
      File Type : JPG, JPEG, PNG, PDF
      <br />
      Maximum Size : 2 MB
    </p>
  );
};
export const AllowedFileText12MB = ({ topmargin }) => {
  return (
    <p className="form-text" style={{ marginTop: topmargin }}>
      File Type : JPG, JPEG, PNG, PDF
      <br />
      Maximum Size : 12 MB
    </p>
  );
};

export const isLoadingAction = (res, dispatch) => {
  dispatch({
    type: IS_LOADING,
    payload: {
      type: IS_LOADING,
      payload: res,
    },
  });
};

export const staticRangesDatePicker = [
  {
    label: "Today",
    range: () => ({
      startDate: startOfDay(new Date()),
      endDate: endOfDay(new Date()),
    }),
    isSelected(range) {
      const definedRange = this.range();
      return (
        isSameDay(range.startDate, definedRange.startDate) &&
        isSameDay(range.endDate, definedRange.endDate)
      );
    },
  },
  {
    label: "Yesterday",
    range: () => ({
      startDate: startOfDay(addDays(new Date(), -1)),
      endDate: endOfDay(addDays(new Date(), -1)),
    }),
    isSelected(range) {
      const definedRange = this.range();
      return (
        isSameDay(range.startDate, definedRange.startDate) &&
        isSameDay(range.endDate, definedRange.endDate)
      );
    },
  },
  {
    label: "This Week",
    range: () => ({
      startDate: startOfWeek(new Date()),
      endDate: endOfDay(new Date()),
    }),
    isSelected(range) {
      const definedRange = this.range();
      return (
        isSameDay(range.startDate, definedRange.startDate) &&
        isSameDay(range.endDate, definedRange.endDate)
      );
    },
  },
  {
    label: "Last Week",
    range: () => ({
      startDate: startOfWeek(addDays(new Date(), -7)),
      endDate: endOfWeek(addDays(new Date(), -7)),
    }),
    isSelected(range) {
      const definedRange = this.range();
      return (
        isSameDay(range.startDate, definedRange.startDate) &&
        isSameDay(range.endDate, definedRange.endDate)
      );
    },
  },
  {
    label: "This Month",
    range: () => ({
      startDate: startOfMonth(new Date()),
      endDate: endOfDay(new Date()),
    }),
    isSelected(range) {
      const definedRange = this.range();
      return (
        isSameDay(range.startDate, definedRange.startDate) &&
        isSameDay(range.endDate, definedRange.endDate)
      );
    },
  },
  {
    label: "Last Month",
    range: () => ({
      startDate: startOfMonth(addMonths(new Date(), -1)),
      endDate: endOfMonth(addMonths(new Date(), -1)),
    }),
    isSelected(range) {
      const definedRange = this.range();
      return (
        isSameDay(range.startDate, definedRange.startDate) &&
        isSameDay(range.endDate, definedRange.endDate)
      );
    },
  },
  {
    label: "This Year",
    range: () => ({
      startDate: startOfYear(new Date()),
      endDate: endOfDay(new Date()),
    }),
    isSelected(range) {
      const definedRange = this.range();
      return (
        isSameDay(range.startDate, definedRange.startDate) &&
        isSameDay(range.endDate, definedRange.endDate)
      );
    },
  },
];

export const APIHEADER = {
  Authorization: getToken(),
  ApiKey: API_KEY,
  MenuId: getNetworkMenuId()?.menuId,
};

export  function reverseString(str) {
  return (str === '') ? '' : reverseString(str.substr(1)) + str.charAt(0);
}
